import React, { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '../contexts/AuthContext';
import { NotificationProvider } from '../notifications/NotificationContext';
import { AppToastProvider } from '../components/shared/app/AppToast';
import { queryClient } from './queryClient';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <AppToastProvider>
        <NotificationProvider>{children}</NotificationProvider>
      </AppToastProvider>
    </AuthProvider>
  </QueryClientProvider>
);
